export const apiRoutes = {
  api_r_user_module_qseReports_getModuleData: {
    path: 'm/qse-reports/get-module-data/',
  },
  api_r_user_module_qseReports_getReportData: {
    path: 'm/qse-reports/get-report-data/',
  },
  api_r_user_module_qseReports_editReport: {
    path: 'm/qse-reports/edit-report/',
  },
  api_r_user_module_qseReports_getFile: {
    path: 'm/qse-reports/get-file/',
  },
  api_r_user_module_qseReports_toggleQualityOmBlock: {
    path: 'm/qse-reports/toggle-quality-om-block/',
  },
  api_r_user_module_qseReports_editQualityOmBlockInitialDate: {
    path: 'm/qse-reports/edit-quality-om-block-initial-date/',
  },
  api_r_user_module_qseReports_getXlsReport: {
    path: 'm/qse-reports/get-xls-report/',
  },
};
